import { render, staticRenderFns } from "./EditModule.vue?vue&type=template&id=28d699d6&scoped=true&"
import script from "./EditModule.vue?vue&type=script&lang=js&"
export * from "./EditModule.vue?vue&type=script&lang=js&"
import style0 from "./EditModule.vue?vue&type=style&index=0&id=28d699d6&prod&lang=less&scoped=true&"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d699d6",
  null
  
)

export default component.exports